module.exports = __webpack_public_path__ + "b00b5b23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/icon-supplies-moving.png
// module id = 1539
// module chunks = 0